import { render, staticRenderFns } from "./VesselMonitoringBayDeck.vue?vue&type=template&id=0ba53620&scoped=true"
import script from "./VesselMonitoringBayDeck.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringBayDeck.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringBayDeck.vue?vue&type=style&index=0&id=0ba53620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba53620",
  null
  
)

export default component.exports